define('controllers/invoices',['require','johngrid','ractivejs','utils','arrayUtils','services/InvoiceCorrections','rv!templates/invoicecorrections'],function(require) {
    var CreateJohnGrid = require('johngrid');
    var Ractive = require('ractivejs');
    var utils = require('utils');
    var arrayUtils = require('arrayUtils');
    var InvoiceCorrections = require('services/InvoiceCorrections');

	return function() {
		$(function () {
		    var grid = CreateJohnGrid(),
		        columns = [
		            { DataField: "BookingName", HeaderText: "Booking Name" },
		            { DataField: "StartDate", HeaderText: "Check In" },
		            { DataField: "EndDate", HeaderText: "Check Out" },
		            { DataField: "Hotel", HeaderText: "Hotel" },
		            { DataField: "RoomRateTotal", HeaderText: "Total" },
		            { DataField: "HotelFeesTotal", HeaderText: "Fees" },
		            { DataField: "HotelTaxFeesTotal", HeaderText: "Taxes" },
		            { DataField: "ManualChangeNotes", HeaderText: "Manual Change Notes" },
		            { DataField: "FolioNumber", HeaderText: "Folio" },
		            { DataField: "InvoiceNumber", HeaderText: "Invoice Number" },
		            { DataField: "InvoiceCreator", HeaderText: "Invoice Creator" },
		            { DataField: "InvoiceCreateDate", HeaderText: "Invoice Created" },
		            { DataField: "InvoiceModifiedDate", HeaderText: "Invoice Last Modified" },
		            { DataField: "StatusName", HeaderText: "Status", SortField: "StatusSortOrder" },
		            { DataField: "Comments", HeaderText: "<span style='display:block;margin-right:50px;'>Comments</span>" },
					{ DataField: "ConfirmationNumber", HeaderText: "Confirmation Number" },
					{ DataField: "RecordLocator", HeaderText: "Record Locator" },
		        ],
		        AjaxUrl = "Invoices_Ajax.aspx",
		        ddlInvoiceStatus = $("#ddlInvoiceStatus"),
		        txtSearchHotels = $(".txtSearchHotels").first(),
		        ddlTake = $("#ddlTake"),
                ddlInvoiceDates = $("#ddlInvoiceDates"),
		        txtSearchName = $("#txtSearchName"),
		        txtSearchFolio = $("#txtSearchFolio"),
		        txtInvoiceNumber = $("#txtInvoiceNumber"),
		        divCount = $("#divCount");

		    var ic = new InvoiceCorrections();
		    var cr = null;
		    var taxGrid = null;

		    function SetUpStatusDropDowns() {
		        var options = [],
					optionsTemplate = "<option value='{0}'>{1}</option>";

		        var invoiceStatuses = window.ServerData.feData.invoiceStatuses;
		        for (var i = 0; i < invoiceStatuses.length; i++) {
		            var status = invoiceStatuses[i];
		            options.push(optionsTemplate.format(status.id, status.Name));
		        }
		        var optionsHTML = options.join("");
		        ddlInvoiceStatus.append(optionsHTML);
		    }
		    SetUpStatusDropDowns();

		    /**
		     * Note that we must build it everytime, since ractive totally removes the elements from the template
		     * @returns {} 
		     */
		    function SetUpDetailGrid() {
		        cr.set('showDetails', true);
		        var setup = taxGrid != null;
		        var ds = setup ? taxGrid.currentDataSource : []; 
		        taxGrid = CreateJohnGrid();
		        taxGrid.init($("#tbl_Taxes"), undefined, "taxAJAX.aspx");
		        taxGrid.onDataBinding = function () {
		            taxGrid.columns = []; //force rebuild columns, since it is dynamic. That way, the sproc selection can be changed.
		            taxGrid.dsPostValues.vacDestId = grid.utilities.selectedItem.DestinationID;
		        };

		        taxGrid.onDataBound = function () {
		            //Highlight row that should have been used. Where createdate between start/end.
		            var vacation_createDate = Date.parse(grid.utilities.selectedItem.VacationCreateDate);

		            for (var i = 0; i < taxGrid.currentDataSource.length; i++) {
		                var item = taxGrid.currentDataSource[i],
                            start = Date.parse(item.StartDate),
                            end = Date.parse(item.EndDate);

		                if (vacation_createDate >= start && vacation_createDate <= end) {
		                    $("tr[data-itemindex='{0}']".format(i), taxGrid.$table).css("background-color", "yellow"); //should only be one row, but highlight ANY that work...
		                }
		            }
		        }
		        taxGrid.databind(ds.length > 0 && setup ? ds : undefined);
		    }

			grid.UIComponents.BackButtonText = "Back To Search Results";
			grid.pkColumnName = "DestinationID";
			grid.sorting.allowSorting = true;
			grid.dsPostValues.sortClause = "StartDate";
			grid.onDataBinding = function () {
				grid.dsPostValues.HotelId = txtSearchHotels.attr("data-selectedValue");
				grid.dsPostValues.InvoiceStatus = ddlInvoiceStatus.val();
				grid.dsPostValues.Take = ddlTake.val();
				grid.dsPostValues.InvoiceDates = ddlInvoiceDates.val();
				grid.dsPostValues.BookingName = GetSearchValue(txtSearchName);
				grid.dsPostValues.Folio = GetSearchValue(txtSearchFolio);
				grid.dsPostValues.InvoiceNumber = GetSearchValue(txtInvoiceNumber);
			};
			grid.onCreatingRows = function () {
				divCount.text("Rows: " + grid.currentDataSource.Count);
				grid.currentDataSource = grid.currentDataSource.vacations;
			};

            /**
             * If the normal save succeeds, save the corrections
             * @param {} item 
             * @returns {} 
             */
			grid.utilities.beforeSave = function (item) {
			    var invoice = cr.getVal();
			    item.Correction = JSON.stringify({
			        VacationDestinationId: invoice.DestinationID,
			        Nights: invoice.Nights,
			        Refund: invoice.Refund,
			        Comment: invoice.Refund ? invoice.ManualChangeNotes : invoice.CorrectionComment
			});
			}

			function GetSearchValue($box) {
				return $box.val() == $box.attr("placeholder") ? "" : $box.val().trim();
			}

            function showDetailsIfInvalid(changeStatus) {
                //if any totals don't match, go ahead and show the tax grid right away
                var invoice = cr.getVal();
                if (invoice.InvoiceRoomRateTotal != invoice.RoomRateTotal ||
                    invoice.InvoiceFeesTotal != invoice.HotelFeesTotal ||
                    invoice.InvoiceTaxTotal != invoice.HotelTaxFeesTotal) {
                    if (!invoice.showDetails) {
                        if (changeStatus){ cr.set('StatusId', 1);} //needs corrections
                        SetUpDetailGrid();
                    }
                } else {
                    cr.set('showDetails', false);
                    if (changeStatus) {cr.set('StatusId', 4);} //ready for review
                }
            }

            function setUpNumberBoxes() {
                $(".NumberBox").off('change').on('change', function () {
                    var $this = $(this),
                        value = $this.val().replace(/\$|,/g, ""); //remove "$" and ",". If need a more whitelist solution, use /[^\d\-\/\*\s\t]/g -- only allows numbers, "-", "+", "/", "*", spaces, and tabs

                    var code = 'try { value = eval(value); } catch(err) { alert("I am but a humble calculator box. I didn\'t understand what you typed. Please use simple mathematic commands (+, -, /, and *)."); }';
                    eval(code);

                    $this.val(value == null ? '' : value); //for manual booking number crunchin'
                });
            }

		    /**
             * Checks if the vacation destination has any corrections.
             * @returns {bool} 
             */
            function hasCorrections(invoice) {
                return invoice.Nights.length > 0 && invoice.Nights.some(function (night) {
                    return night.DestinationRoomRate !== night.RoomRate ||
                        night.DestinationHotelFees !== night.HotelFees ||
                        night.DestinationHotelTaxFees !== night.HotelTaxFees;
                });
            }

            /**
             * Disable the text boxes in the invoice corrector and set the title attributes to exlain why it's disabled
             * @param {string} explanation  
             */
            function disableCorrectorBoxes(explanation) {
                $('.editgrid input').prop('disabled', true).attr('title', explanation);
            }

            /**
             * Enables all the boxes and removes the title attribute
             */
            function enableCorrectorBoxes() {
                $('.editgrid input').prop('disabled', false).removeAttr('title');
            }

		    /**
             * Sets prop1 to be the value of prop2
             * @param {string} prop1 
             * @param {string} prop2 
		     * @return {func} closure function, since ractive doesn't appear to have a way to provide params to event handlers
             */
            function match(prop1, prop2) {
                return function() {
                    cr.set(prop1, cr.get(prop2));
                };
            }

		    /**
             * Retrieve the distinct, non-null correction comments and delimit by newlines
             * @returns {string} 
             */
            function getDistinctCorrectionComments(invoice) {
		        return arrayUtils.distinct(invoice.Nights.filter(function(night) {
		            return night.Comment != null;
		        }), 'Comment').join('\n\n');
		    }

		    /**
             * Get ractive template initiated...
             */
            function setUpInvoiceCorrectionsGrid(invoice) {
			    invoice.invoiceStatuses = window.ServerData.feData.invoiceStatuses;
			    invoice.showDetails = false;
			    invoice.Refund = ic.shouldRefund(invoice);
			    invoice.utils = utils;
			    invoice.helpers = { getTotalDiff: function () { } }; //stub out helpers so ractive doesn't complain
			    invoice.hasCorrections = hasCorrections(invoice);
                invoice.CorrectionComment = getDistinctCorrectionComments(invoice);
			    cr = new Ractive({
			        el: '#invoiceCorrections',
			        template: require('rv!templates/invoicecorrections'),
			        data: invoice
			    });
                taxGrid = null;

                //parse values that should be numbers as floats, since we're using NumberBoxes which will make the value a string
                cr.getVal = function() {
                    var r = cr.get();
                    r.RoomRateTotal = parseFloat(r.RoomRateTotal);
                    r.HotelFeesTotal = parseFloat(r.HotelFeesTotal);
                    r.HotelTaxFeesTotal = parseFloat(r.HotelTaxFeesTotal);

                    r.InvoiceRoomRateTotal = parseFloat(r.InvoiceRoomRateTotal);
                    r.InvoiceFeesTotal = parseFloat(r.InvoiceFeesTotal);
                    r.InvoiceTaxTotal = parseFloat(r.InvoiceTaxTotal);

                    $.each(r.Nights, function(index, night) {
                        night.RoomRate = parseFloat(night.RoomRate);
                        night.HotelFees = parseFloat(night.HotelFees);
                        night.HotelTaxFees = parseFloat(night.HotelTaxFees);
                        night.DestinationRoomRate = parseFloat(night.DestinationRoomRate);
                        night.DestinationHotelFees = parseFloat(night.DestinationHotelFees);
                        night.DestinationHotelTaxFees = parseFloat(night.DestinationHotelTaxFees);
                    });
                    return r;
                };

                cr.set('helpers', {
                    /**
                     * determine the total difference between what we charged the member and what the hotel invoiced us
                     * @returns {} 
                     */
			        getTotalDiff: function() {
			            var invoice = cr.getVal();
			            var diff = (invoice.RoomRateTotal + invoice.HotelFeesTotal + invoice.HotelTaxFeesTotal) - (invoice.InvoiceRoomRateTotal + invoice.InvoiceFeesTotal + invoice.InvoiceTaxTotal);
			            return utils.roundNumber(diff, 2);
			        }
			    });
			    $("#txtInvoiceDate").datepicker();
			    showDetailsIfInvalid(false);
                cr.off().on({
                    showDetailsData: function(e) {
                        e.original.preventDefault();
                        SetUpDetailGrid();
                    },

                    /**
                     * Revert back to original destination values, use those for the corrections
                     * @param {object} invoice 
                     */
                    revertCorrections: function(e) {
                        e.original.preventDefault();
                        var invoice = cr.get();
                        $.each(invoice.Nights, function(i, night) {
                            night.RoomRate = night.DestinationRoomRate;
                            night.HotelFees = night.DestinationHotelFees;
                            night.HotelTaxFees = night.DestinationHotelTaxFees;
                        });
                        cr.set('DisplayOld', false);
                        cr.set('Nights', invoice.Nights);
                        enableCorrectorBoxes();
                    },

                    /**
                     * the invoice usually just has the total, so if it matches our total, set all the invoice amounts to be equal to our amounts
                     */
                    onOursEqualsTheirs: function (e) {
                        match('InvoiceRoomRateTotal', 'RoomRateTotal')();
                        match('InvoiceFeesTotal', 'HotelFeesTotal')();
                        match('InvoiceTaxTotal', 'HotelTaxFeesTotal')();
                    },

                    matchRoomRateTotal: match('RoomRateTotal', 'InvoiceRoomRateTotal'),
                    matchInvoiceRoomRateTotal: match('InvoiceRoomRateTotal', 'RoomRateTotal'),
                    matchHotelFeesTotal: match('HotelFeesTotal', 'InvoiceFeesTotal'),
                    matchInvoiceFeesTotal: match('InvoiceFeesTotal', 'HotelFeesTotal'),
                    matchHotelTaxFeesTotal: match('HotelTaxFeesTotal', 'InvoiceTaxTotal'),
                    matchInvoiceTaxTotal: match('InvoiceTaxTotal', 'HotelTaxFeesTotal')
                });

			    //when nights change, set up our totals
			    var nightsChanged = function (newVal, oldVal) {
			        unsetObserves();
			        var invoice = cr.getVal();
			        invoice.DisplayOld ? disableCorrectorBoxes('To make corrections, uncheck "Show Original Values" to see the corrections again or choose "Revert To Original Values".') : enableCorrectorBoxes();
			        cr.set('RoomRateTotal', utils.roundNumber(arrayUtils.sum(invoice.Nights, invoice.DisplayOld ? 'DestinationRoomRate' : 'RoomRate'), 2));
			        cr.set('HotelFeesTotal', utils.roundNumber(arrayUtils.sum(invoice.Nights, invoice.DisplayOld ? 'DestinationHotelFees' : 'HotelFees'), 2));
			        cr.set('HotelTaxFeesTotal', utils.roundNumber(arrayUtils.sum(invoice.Nights, invoice.DisplayOld ? 'DestinationHotelTaxFees' : 'HotelTaxFees'), 2));
			        showDetailsIfInvalid(true);
			        setObserves();
			    };

			    //when our totals change, set up nights
			    var totalChanged = function (newVal, oldVal) {
			        unsetObserves();
			        var invoice = cr.getVal();
			        var newNights = ic.generateCorrectionNights(invoice.RoomRateTotal, invoice.HotelFeesTotal, invoice.HotelTaxFeesTotal, invoice.Nights);
			        cr.set('Nights', newNights);
			        showDetailsIfInvalid(true);
			        setObserves();
			    }

                //when the invoice totals change
                var invoiceTotalsChanged = function() {
                    cr.set('Refund', ic.shouldRefund(cr.get()));
                    showDetailsIfInvalid(true);
                }

                //observe manager...need to not go through first load and also not affect dependent observes to avoid observe handles from affecting observe listeners
			    var cancels = [];
			    function setObserves() {
			        var opts = { init: false };
			        cancels = [
                        cr.observe('Nights DisplayOld', nightsChanged, opts),
                        cr.observe('RoomRateTotal HotelTaxFeesTotal HotelFeesTotal', totalChanged, opts),
                        cr.observe('InvoiceRoomRateTotal InvoiceFeesTotal InvoiceTaxTotal', invoiceTotalsChanged, opts)
			        ];
			    }
			    setObserves();

                function unsetObserves() {
                    $.each(cancels, function(index, c) {
                        c.cancel();
                    });
                }

			    //accountant boss only
                var isAccountantBoss = window.ServerData.user.roles.some(function(role) { return role === 'Admin' || role === 'AccountantBoss'; });
                if (!isAccountantBoss) {
                    disableCorrectorBoxes('Must be an accountant boss to make corrections.');
                    $('#chkRefund').prop('disabled', true);
                }

                //initiate numberboxes
                setUpNumberBoxes();

                //first we need to update "our" totals to be based on the nights instead of what we have in the vacationdestination table
                nightsChanged(); 
            }

			grid.selectHelpers.onSelect = setUpInvoiceCorrectionsGrid;
			grid.editHelpers.onEdit = setUpInvoiceCorrectionsGrid;

			grid.editHelpers.init($("#editForm"));
			grid.utilities.validateItem = function (item) {
			    var invoice = cr.getVal();
				var errors = [];
				if (invoice.FolioNumber == null) {
					errors.push("Please fill in Folio Number.");
				}
				if (isNaN(Date.parse(invoice.InvoiceDate))) {
					errors.push("Please enter a date for Invoice Date.");
				}
				if (invoice.Nights.some(function (night) {
				    return night.RoomRate < 0 || night.HotelFees < 0 || night.HotelTaxFees < 0;
				})) {
				    errors.push('Negative values are not allowed for corrections.');
				}
				return errors;
			};

			grid.init($("#tbl_Vacation_Destinations"), columns, AjaxUrl);
			$(".johnGridHeader", grid.$table).prepend($("#headerTemplate"));
			grid.loadItem(utils.querystring('d'));

			SearchHotels_EventHandlers.onChange = GridDataBind;
			ddlInvoiceStatus.on("change", GridDataBind);
			ddlTake.on("change", GridDataBind);
			ddlInvoiceDates.on("change", GridDataBind);
			//GridDataBind();

			function GridDataBind() {
				grid.databind(); //setting the handlers directly to this function causes issues. Something to do with how it's stored in memory, probably. Not sure, though...
			}

			Utilities.setDefaultButton($("#headerTemplate"), $(".btnRefresh", grid.$table));
			txtSearchName.focus();
		});
	};
});
